export default {
  loadingText: {
    id: 'dashboard_diagnosis_loading_title',
    defaultMessage: 'Ok, letʼs have a closer look…',
  },
  toastTitle: {
    id: 'diagnosis_customer_issue_invoice_request_failed_title',
    defaultMessage: 'Something went wrong',
  },
  toastContent: {
    id: 'diagnosis_customer_issue_invoice_request_failed_content',
    defaultMessage: 'Your request didn’t go through. Please try again.',
  },
}
